// Project pipeline statuses (client doc "Statut Prospect Partenaire"):
// Prospection, Intéressé, En signature, Vente, Nurserie, Perdu, Abandon Projet.
// [stored code, i18n label] — the first three codes are the values existing
// projects / actions already hold, so no data migration is needed.
const PROJECT_STATUSES = [
  ["Prospect", "Prospecting"],
  ["Interested", "Interested"],
  ["Pending signature", "In signature"],
  ["Sale", "Sale"],
  ["Nursery", "Nursery"],
  ["Lost", "Lost"],
  ["Abandoned", "Project abandoned"],
];

export const projectStatusOptions = (t) =>
  PROJECT_STATUSES.map(([code, label]) => ({ name: t(label), code }));

/** Label of a stored status (older values such as "In discussion" as-is). */
export const projectStatusLabel = (code, t) =>
  t(`${PROJECT_STATUSES.find(([value]) => value === code)?.[1] ?? code ?? ""}`);
